const getMainMemberInfo = (state) => {
  return state.pages.shop.mainMember.data;
};

const getUserLoggedIn = (state) => {
  return state.pages.shop.mainMember.loggedIn;
};

export { getMainMemberInfo, getUserLoggedIn };
